// extracted by mini-css-extract-plugin
export default {"fixcenter_support_see_detail_content":"FixcenterSupportSeeDetail_fixcenter_support_see_detail_content__-tIOJ","text":"FixcenterSupportSeeDetail_text__siwP3"};